<img class="id-photo" *ngIf="piuPhotoUrl && size" src="{{piuPhotoUrl}}" [width]="size" [height]="size">
